import React from 'react';
import { Link } from 'react-router-dom';
import CTASection from '../components/CTASection';
import './About.css';

const features = [
  { icon: '📱', title: 'Mobile & Remote First', desc: 'No need to visit an office. We handle everything digitally — secure, convenient, and hassle-free from anywhere in the US.' },
  { icon: '🔐', title: 'Secure & Confidential', desc: 'Your financial data is handled with bank-level security. We comply with all IRS data protection requirements.' },
  { icon: '💡', title: 'Expert Tax Knowledge', desc: 'From ITIN applications to complex business filings, our experts know every deduction available to you.' },
  { icon: '⚡', title: '24–48 Hour Turnaround', desc: 'Fast filing means faster refunds. We don\'t keep you waiting — your return is filed within 1–2 business days.' },
  { icon: '🗺️', title: 'Nationwide Service', desc: 'We proudly serve clients in all 50 states. Wherever you are, we help you file correctly and maximize your return.' },
];

const About = () => (
  <>
    {/* Page Header */}
    <div className="page-header">
      <div className="container">
        <div className="section-label">Who We Are</div>
        <h1>About <em>A-Mobile Tax Services</em></h1>
        <p>Trusted tax preparation experts based in Evanston, IL — serving all 50 states.</p>
      </div>
    </div>

    {/* About Content */}
    <section className="section">
      <div className="container">
        <div className="about-grid">
          <div className="about-card">
            <h2>Our Story</h2>
            <p>A-Mobile Tax Services is a trusted tax preparation service based in Evanston, Illinois, serving clients across all 50 states.</p>
            <p>We specialize in helping individuals, families, and small businesses maximize their refunds while staying fully compliant with IRS regulations.</p>
            <p>Whether you are a W-2 employee, self-employed, Uber driver, or business owner, we provide accurate, fast, and secure tax solutions tailored to your needs.</p>
            <div className="about-mission">
              👉 Our mission is simple: <strong>Help you keep more of your money.</strong>
            </div>
            <div className="about-actions">
              <Link to="/contact" className="btn btn-gold">📲 Get Started Today</Link>
              <Link to="/services" className="btn btn-outline-navy">View Services</Link>
            </div>
          </div>

          <div className="about-features">
            {features.map((f) => (
              <div className="about-feature" key={f.title}>
                <div className="feature-icon">{f.icon}</div>
                <div>
                  <strong>{f.title}</strong>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <CTASection />
  </>
);

export default About;
